<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>{{isCreating?'Crea un area':'Edita un area'}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="area" class="form-label">Nombre del area<span
							class="required">*</span></label>
						<input type="text" placeholder="Ingresa el nombre del area" name="area"
							id="area" [(ngModel)]="newArea.name" class="form-control">
					</div>
					<div class="form-group">
						<label for="warehouse" class="form-label">Ubicación</label>
						<select name="warehouse" id="warehouse" class="form-select" [(ngModel)]="newArea.warehouse">
							<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}</option>
						</select>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'crear el area':'guardar los cambios'}} </p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!newArea || loading"
						(click)="createOrEdit()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>{{isCreating?'CREAR':'EDITAR'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>